import type { PromotionList } from './promotions.schema'

export const PROMOTIONS: PromotionList = []
